import { render, staticRenderFns } from "./BaseLeaderCard.vue?vue&type=template&id=19716eda&"
import script from "./BaseLeaderCard.vue?vue&type=script&lang=js&"
export * from "./BaseLeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseLeaderCard.vue?vue&type=style&index=0&id=19716eda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports